module.exports = __webpack_public_path__ + "static/media/MilhoPipoca.048f3c63.png";